<template>
  <div id="mqttws" class="disConnected">
    <!-- {{urlQuery}} -->
  </div>
</template>
<style>
#mqttws {
  height: 100px !important;
  z-index: 100000;
  position: fixed;
}
.disConnected {
  color: red;
  height: 100px;
  border-radius: 50%;
  position: fixed;
  right: 0;
  z-index: 100001;
}
</style>
<script>
import {ref, computed, reactive, toRefs } from "vue";
import Paho from "./js/mqtt.js";
import { createState } from "../store";
import { useRouter } from "vue-router";
var opt;
export default {
  name: "mqttws",
  data() {
    return {
      client: {},
      options: {},
      msg: "order",
      count: 0,
      connected: false,
      commandType: "",
      deviceInfo: "",
      state: reactive(createState),
      projectTopic:location.search.split('=')[1]
    };
  },
  created() {
    console.log(this.state)
    let _this = this;
    // 获取storage里的配置参数
    this.client = new Paho.MQTT.Client(
      this.state.brokerip,
      8083,
      "WX_" + new Date().getTime()
    );
    this.state.client = this.client
    var _client = this.client;
    opt = this.options = {
      timeout: 5,
      keepAliveInterval: 50,
      reconnect: true, // Enable automatic reconnect
      cleanSession: false,
      useSSL: false,
      userName: "",
      password: "",
      onSuccess: function() {
        console.log("连接成功");
        _this.topicFun();
      },
      onFailure: function(e) {
        setTimeout(function() {
          _client.connect(opt);
        }, 5000);
      }
    };
    this.client.connect(opt); //连接服务器并注册连接成功处理事件
    this.client.onConnectionLost = this.onConnectionLost; //注册连接断开处理事件
    this.client.onMessageArrived = this.onMessageArrived; //注册消息接收处理事件
  },
  mounted: function() {
    // this.$store.commit("setQuery", this.$route.query);
  },
  methods: {
    //获取pdf
    getfileFun(){
      console.log(this.state.selectedMatchId)
      const data= {
        'matchId' :this.state.selectedMatchId
      }
      this.$http.get('/File/GetMatchFiles?matchId='+this.state.selectedMatchId,data,{
        headers:{
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
      })
      .then((res)=>{
        console.log(res)
        if(res.status==200&&res.data.Code==0){
          this.state.pdfmatchList = res.data.Result[0].MatchFileList
          this.state.pdfprojectList = res.data.Result[0].ProjectFileList
          this.state.pdfmatchList.map((item)=>{
            if(item.FileType==100){//比赛秩序单
              item.name = '比赛秩序单'
            }else if(item.FileType==101){//比赛成绩册
              item.name = '比赛成绩册'
            }
          })
          this.state.pdfprojectList.map((item)=>{
             if(item.FileType==200){//比赛成绩册
              item.name = '项目秩序单'
            }else if(item.FileType==2001){//比赛成绩册
              item.name = ' 项目成绩单'
            }
          })
        }else if(res.status==200&&res.data.Code==204){
          console.log('无数据')
           this.state.pdfmatchList = []
           this.state.pdfprojectList = []
        }
      })
      .catch((res)=>{
        
        console.log(res)
      })
    },
    topicFun() {
      const MQTT_TOPIC = this.state.matchTopic;
      this.client.subscribe(MQTT_TOPIC); //订阅监控通用指令
    },
    onConnectionLost: function(responseObject) {
      if (responseObject.errorCode !== 0) {
        console.log("onConnectionLost:" + responseObject.errorMessage);
        this.connected = false;
        console.log("连接已断开");
      }
    },
    onMessageArrived: function(message) {
      try {
        const list = JSON.parse(message.payloadString);
        //对监听到的数据进行处理
        //this.state.menuList 比赛列表 展示比赛名称信息
        //判断受到的topic是否与NSSP0001/CompetitionListFlat相同 
        if(this.state.pdfmatchList.length==0){
          // this.getfileFun()
        }
        if(message.topic==this.state.matchTopic){
          // this.getfileFun()//收到NSSP0001/CompetitionListFlat消息重新请求新的pdf文件
          this.state.matchList.value = list;
          this.state.menuList.value = list.menuList;
          // this.state.showYear.value = [this.arrMatchYear()[0]];
          this.state.menuList.value = this.getMatchList()
          this.state.groupList.value = this.arrMatchGroup();
          this.state.active = this.state.active ==0? this.state.groupList.value[0]:this.state.active
          console.log(this.state.active)
          this.state.projectList.value = this.arrMatchProject(this.state.active);
        }
        //判断收到的topic是否与请求的topic一致  
        //判断是否收到 订阅的projectTopic 一致的成绩信息 收到成绩信息组织数据跳转到对应页面
        if(this.$route.path.indexOf('ranking')!='-1'&&message.topic==this.state.matchTopic){
          this.state.propshowData = this.filterliveMenuByPrjoect(this.state.projectInfo.groupName,this.state.projectInfo.matchProjectName)
        }
        if(message.topic==this.state.projectTopic){
          
          console.log('收到订阅的项目信息')
          const dataList = JSON.parse(message.payloadString);
          //判断是否比赛结束进入到颁奖界面
          var newPath = ''
          if(dataList.projectInfo.projectScreenType==5){
             newPath = "/award"+`/${ dataList.projectInfo.distance}${ dataList.projectInfo.projectType}`
             this.$router.push({
                path: newPath,
                query: {projectTopic:this.state.projectTopic}
              });
          }else{
             newPath = "/ranking"+`/${ dataList.projectInfo.distance}${ dataList.projectInfo.projectType}`
          }
          this.state.matchInfo = list.matchInfo//保存比赛信息
          this.state.projectInfo = dataList.projectInfo//保存项目信息
          this.matchName = list.matchInfo.matchName//存储比赛名称
          this.state.selectedMatchId = list.matchInfo.matchID//存储比赛id
          //展示路由名
          this.state.svgComponentName = "svg" +list.projectInfo.distance +list.projectInfo.gunType;
          //侧滑弹窗展示list
          this.state.propshowData = this.filterliveMenuByPrjoect(dataList.projectInfo.groupName,dataList.projectInfo.matchProjectName)
          //根据比赛类型进行展示数据拼接 Qualification Final
          if(!list.dataList&&list.topList.length>0){
            this.state.showList.value = list.topList
            //########################
            //测试团体赛 每队三人的情况
            // const listtext = [...list.topList]
            // console.log(listtext[0])
            // listtext.push(listtext[0])
            // listtext.push(listtext[1])
            // this.state.showList.value = listtext
            //########################
          }else if(!list.topList&&list.dataList.length>0){
            this.state.showList.value = list.dataList
          } else{
            this.state.showList.value = list.topList.concat(list.dataList)
          }
          //当前不在ranking页面跳转到ranking
          if(this.$route.path.indexOf('ranking')=='-1'){
            this.$router.push({
              path: newPath,
              query: {projectTopic:this.state.projectTopic}
            });
          }else{
          }
          if(this.state.topicType){
            console.log('选择项目的其他阶段')
            this.$router.push({
              path: newPath,
              query: {projectTopic:this.state.projectTopic}
            });
            this.state.show = false
            this.state.topicType = false
          }
        }
        //根据id整理组别和项目
        if(this.state.selectedMatchId!=''&&!this.state.groupList.value){
          console.log('根据id整理组别和项目')
          this.state.groupList.value = this.arrMatchGroup();
          this.state.projectList.value = this.arrMatchProject(this.state.groupList.value[0]);
        }
        if(this.projectTopic!==''&&!this.state.showList.value&&this.projectTopic!==undefined){
          console.log('刷新页面重新监听比赛成绩')
          this.state.projectTopic = this.projectTopic
          this.client.subscribe(this.state.projectTopic); //订阅监控通用指令
        }
        console.log(list)
        // console.log(this.state)
      } catch (error) {
        console.log(error);
      }
    },
    onConnect: function() {},
    display: function(message) {
      console.log(message);
    },
    // 处理select筛选后的数组
    selectedLiveMenu() {
      return this.state.matchList.value.menuList.filter(match => {
        return match.matchId == this.state.selectedMatchId;
      });
    },
    // 根据年份获取比赛列表
    getMatchList() {
      let arr = [];
      let arrMatchId = [];
      this.state.menuList.value.forEach((item) => {
        if (
          arrMatchId.indexOf(item.matchId) == -1 
        ) {
          arrMatchId.push(item.matchId);
          let addArr = item;
          arr.push(addArr);
        }
      });
      // 设置默认选择项
      return arr;
    },
    // 获取所有年份
    arrMatchYear() {
      let arr = [];
      this.state.menuList.value.forEach(item => {
        if (arr.indexOf(item.matchYear) == -1) {
          arr.push(item.matchYear);
        } else {
          return false;
        }
      });
      return arr.sort().reverse();
    },
    // 获取所有组别
    arrMatchGroup() {
      let arr = [];
      this.selectedLiveMenu().forEach(item => {
        if (arr.indexOf(item.matchGroupName) == -1) {
          arr.push(item.matchGroupName);
        } else {
          return false;
        }
      });
      return arr;
    },
    // 获取所有项目
    arrMatchProject(title) {
      let arr = [];
      this.filterliveMenuByGroup(title).forEach(item => {
        let add = true;
        arr.forEach(arrItem => {
          if (arrItem[0] == item.projectName) {
            add = false;
            return false;
          } else {
            return false;
          }
        });
        if (add) {
          arr.push([item.projectName,item.topic]);
        }
      });
      return arr;
    },
    // 2根据组别筛选比赛
    filterliveMenuByGroup(group) {
      return this.selectedLiveMenu().filter(item => {

        return item.matchGroupName == group;
      });
    },
    // 3根据组别和项目筛选项目类别
    filterliveMenuByPrjoect(group, project) {
      return this.filterliveMenuByGroup(group)
        .filter(item => {
          return item.projectName == project.split('(')[0];//男子25米手枪速射(阶段2) 名称出现阶段，需过滤
        })
        .sort((a, b) => {
          const aTime = a.startTime.replace(/-/g,'/')
          const  bTime =b.startTime.replace(/-/g,'/')
          if(aTime==bTime){
            if(a.groupNo=='all'){
              return 1
            }else{
              return -1
            }
          }
          return new Date(a.startTime.replace(/-/g,'/')) - new Date(b.startTime.replace(/-/g,'/'));
        });
    }
  },
  computed: {}
};
</script>
